/* eslint-disable import/prefer-default-export,max-len,radix, no-extra-boolean-cast */
import { isEmpty, isNil } from 'ramda';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';
import FileDownload from 'js-file-download';

import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';

import { loadExcelRequest, loadExcelFail, loadExcelSuccess } from './excelActions';

export const REQUEST = 'WORK_TIMES_REPORT_REQUEST';
export const SUCCESS = 'WORK_TIMES_REPORT_SUCCESS';
export const FAIL = 'WORK_TIMES_REPORT_FAIL';

const loadWorkTimesReportRequest = () => ({ type: REQUEST });
const loadWorkTimesReportSuccess = (data) => ({ type: SUCCESS, data });
const loadWorkTimesReportFail = () => ({ type: FAIL });

export const loadWorkTimesData = (query) => (dispatch) => {
  dispatch(loadWorkTimesReportRequest());
  return communicate({ url: 'Reports/WorkTimesInPeriod', getParams: Utils.objects.getQueryStringFromObject(query) })
    .then(({ data }) => {
      const { Data } = data;
      if (!Data || isNil(Data) || isEmpty(Data) || isNil(Data.WorkTimes) || isEmpty(Data.WorkTimes)) {
        dispatch(loadWorkTimesReportFail());
        toastr.error(I18n.t('NoDataAvailable'));
      } else {
        dispatch(loadWorkTimesReportSuccess(Data));
      }
    })
    .catch((err) => {
      dispatch(loadWorkTimesReportFail());
      toastrError(err);
    });
};

export const workTimesExcelExport = (params) => (dispatch) => {
  dispatch(loadExcelRequest());
  return communicate({
    url: 'Reports/WorkTimesInPeriodExcel',
    method: 'get',
    responseType: 'blob',
    getParams: Utils.objects.getQueryStringFromObject(params)
  })
    .then((response) => {
      const fileName = response.headers['x-suggested-filename'] || 'Raport.xlsx';
      dispatch(loadExcelSuccess());
      FileDownload(response.data, fileName);
    })
    .catch((err) => {
      dispatch(loadExcelFail());
      toastrError(err);
    });
};
